import axios from "axios";

const API_URL = "https://srinivasafleet.com/api";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();

      if (window.location.pathname !== "/login") {
        window.location.href = "/login?reason=session_revoked";
      }
    }

    return Promise.reject(error);
  }
);

export const registerUser = async (data) => {
  const response = await axios.post(`${API_URL}/register`, data);
  return response.data;
};

export const sendOTP = async (mobile) => {
  const response = await axios.post(`${API_URL}/send-otp`, {
    mobile,
  });

  return response.data;
};

export const verifyOTP = async (mobile, otp) => {
  const response = await axios.post(`${API_URL}/verify-otp`, {
    mobile,
    otp,
  });

  return response.data;
};

export const sendForgotPasswordOtp = async (mobile) => {
  const response = await axios.post(
    `${API_URL}/auth/forgot-password/send-otp`,
    {
      mobile,
    }
  );

  return response.data;
};

export const verifyForgotPasswordOtp = async (
  mobile,
  otp,
  verificationId
) => {
  const response = await axios.post(
    `${API_URL}/auth/forgot-password/verify-otp`,
    {
      mobile,
      otp,
      verification_id: verificationId,
    }
  );

  return response.data;
};

export const resetForgotPassword = async (
  mobile,
  otp,
  verificationId,
  newPassword,
  confirmPassword
) => {
  const response = await axios.post(
    `${API_URL}/auth/forgot-password/reset`,
    {
      mobile,
      otp,
      verification_id: verificationId,
      new_password: newPassword,
      confirm_password: confirmPassword,
    }
  );

  return response.data;
};

export const getCurrentFinancialYear = async () => {
  const response = await axios.get(
    `${API_URL}/auth/current-financial-year`
  );

  return response.data;
};

export const getFinancialYears = async () => {
  const response = await axios.get(
    `${API_URL}/auth/financial-years`
  );

  return response.data;
};

export const loginUser = async (
  mobile,
  password,
  financial_year_id,
  forceLogin = false
) => {
  const response = await axios.post(
    `${API_URL}/auth/login`,
    {
      mobile,
      password,
      financial_year_id: financial_year_id || null,
      force_login: forceLogin,
    }
  );

  return response.data;
};

export const getCurrentUser = () => {
  return {
    user_id: localStorage.getItem("user_id"),
    role_id: localStorage.getItem("role_id"),
    role_name: localStorage.getItem("role_name"),
    full_name: localStorage.getItem("full_name"),
    mobile: localStorage.getItem("mobile"),
    permissions: JSON.parse(
      localStorage.getItem("permissions") || "{}"
    ),
    financial_year_id:
      localStorage.getItem("financial_year_id") || null,
    financial_year_label:
      localStorage.getItem("financial_year_label") || "",
  };
};

export const logoutUser = async () => {
  const token = localStorage.getItem("token");

  try {
    await axios.post(
      `${API_URL}/auth/logout`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (error) {
    console.error("Logout API failed:", error);
  } finally {
    localStorage.clear();
  }
};